import crud from './_crud'
import { callApi } from 'utils/api'
import { showErrorMessage, showSuccessMessage } from 'utils/messages'

import translations from 'utils/translations'

const entity = 'sys_company'
const messageEntity = 'la compañía del sistema'
const messagePluralEntity = 'las compañías del sistema'
const reducerEntity = 'sys_company'
const actions = crud(entity, messageEntity, messagePluralEntity)

export const LOGO_TOKEN_VALIDATED_SUCCESS = 'LOGO_TOKEN_VALIDATED_SUCCESS'
export const LOGO_TOKEN_VALIDATED_ERROR = 'LOGO_TOKEN_VALIDATED_ERROR'

export const logoTokenValidatedSuccess = (logoUrl) => ({
    type: LOGO_TOKEN_VALIDATED_SUCCESS,
    payload: { logoUrl },
})

export const logoTokenValidatedError = (error) => ({
    type: LOGO_TOKEN_VALIDATED_ERROR,
    payload: { error },
})

const loadSysCompanysClientPortal = (options) => {
    return async (dispatch, getState) => {
        const state = getState()
        try {
            const res = await callApi(
                `/sys_company/load_sys_companys_client_portal`,
                {
                    method: 'GET',
                    params: options.params,
                }
            )

            if (res && res.status === 200) {
                dispatch({
                    type: `LOAD_SYS_COMPANYS`,
                    response: res.body,
                })

                return res.body
            } else {
                console.error('Error al cargar sys_companys:', res)
            }

            return []
        } catch (e) {
            return []
        }
    }
}

const deleteSysCompanyAndUser = ({ username, password, id }) => {
    return async (dispatch, getState) => {
        const state = getState()
        try {
            const credentials = { username, password }
            console.log(credentials)
            const res = await callApi(
                '/app/delete_sys_company_by_credentials',
                {
                    method: 'DELETE',
                    body: JSON.stringify(credentials),
                }
            )

            if (res.status === 200) {
                dispatch({
                    type: 'DELETE_SYS_COMPANY',
                    response: { id },
                })
                showSuccessMessage('Compañía eliminado con éxito')
                return res.body
            }
        } catch (e) {
            console.log(e)
        }
    }
}

const getSysCompany = (id, options = {}) => {
    return async (dispatch, getState) => {
        const state = getState()
        const res = await callApi(`/sys_company/get_sys_company/${id}`, {
            method: 'GET',
            headers: {
                Authorization: state.app?.user?.token,
            },
        })
        dispatch({
            type: `LOAD_SYS_COMPANY`,
            response: res.body,
            payload: id,
        })
    }
}

const updateSysCompany = (item, shouldShowSuccessMessage) => {
    return async (dispatch, getState) => {
        const state = getState()
        let res = await callApi(`/sys_company/${item.id}`, {
            method: 'PATCH',
            body: JSON.stringify(item),
            headers: {
                Authorization: state.app?.user?.token,
            },
            successMessage:
                shouldShowSuccessMessage &&
                `Se actualizaron los permisos correctamente.`,
        })

        let stored_item = res.body
        if (res.status == 200) {
            dispatch({
                type: 'UPDATE_COMPANY_PROPERTIES',
                payload: {
                    contact_permits: !!item.contact_permits,
                },
            })
        }
    }
}

const setOrder = (sysCompanies, options = {}) => {
    return async (dispatch, getState) => {
        const state = getState()
        const currentTranslation = translations[state.app.lang]
        try {
            const res = await callApi('/sys_company/set_order/stalls', {
                method: 'PATCH',
                headers: {
                    Authorization: state.app?.user?.token,
                },
                body: JSON.stringify(sysCompanies),
                successMessage: currentTranslation?.updateItemsMessage(
                    currentTranslation?.stalls
                ),
                shouldSkipStatusError: options?.shouldSkipStatusError,
            })

            if (res.status == 200) {
                dispatch({
                    type: 'LOAD_SYS_COMPANY',
                    payload: res.body,
                })
            }
        } catch (e) {}
    }
}

const getFoodStalls = (options = {}) => {
    return async (dispatch, getState) => {
        const state = getState()

        try {
            const res = await callApi('/sys_company/utils/get_food_stalls', {
                method: 'GET',
                headers: {
                    Authorization: state.app.user.token,
                },
                params: options.params,
            })

            return res.body
        } catch (error) {}
    }
}

const loadFoodStalls = (options = {}) => {
    return async (dispatch, getState) => {
        const state = getState()

        try {
            const res = await callApi('/sys_company/utils/load_food_stalls', {
                method: 'GET',
                headers: {
                    Authorization: state.app.user.token,
                },
                params: options.params,
            })

            if (res.status == 200 && res.body?.length >= 1) {
                dispatch({
                    type: `LOAD_${reducerEntity.toUpperCase()}S`,
                    response: res.body,
                })
            }
            return res.body
        } catch (error) {}
    }
}

export const getLastOfTheList = () => {
    return async (dispatch, getState) => {
        try {
            const state = getState()

            const res = await callApi(`/${entity}/stall/last_list`, {
                method: 'GET',
                headers: {
                    Authorization: state.app?.user?.token,
                },
                shouldSkipStatusError: true,
            })

            if (!res.body?.lastOfTheList) {
                throw new Error('')
            }

            return res.body?.lastOfTheList
        } catch (e) {
            throw e
        }
    }
}

export const updateMultipleSysCompanies = (arrayOfItems) => {
    return async (dispatch, getState) => {
        const state = getState()
        const superAdminHeaders = localStorage.getItem('@superAdmin_headers')
        const headers = await JSON.parse(superAdminHeaders)
        try {
            const res = await callApi(
                '/sys_company/update_multiple/sys_companies',
                {
                    method: 'PUT',
                    headers: {
                        username: headers.username,
                        password: headers.password,
                    },
                    body: JSON.stringify(arrayOfItems),
                    successMessage:
                        'Se actualizaron las compañías correctamente.',
                }
            )
        } catch (e) {}
    }
}

export const validateLogoToken = (logoToken) => {
    return async (dispatch) => {
        try {
            // Llamar al API para validar el logo_token
            console.log('logoToken:', logoToken)
            const response = await callApi(
                `/app/validateLogoToken?e=${logoToken}`,
                {
                    method: 'POST',
                    body: JSON.stringify({ logoToken }),
                }
            )
            const data = await response
            console.log('API response:', response)
            if (response) {
                if (data.body.logoUrl) {
                    // Puedes despachar una acción de éxito y devolver el URL del logo
                    dispatch(logoTokenValidatedSuccess(data.body.logoUrl))
                    return data.body.logoUrl
                } else {
                    console.error(
                        'Error: Logo URL not provided in the response'
                    )
                    // Puedes despachar una acción de error si es necesario
                    dispatch(
                        logoTokenValidatedError(
                            'Logo URL not provided in the response'
                        )
                    )
                }
            } else {
                console.error('Error validating logo token:', data.error)
                // Puedes despachar una acción de error si es necesario
                dispatch(logoTokenValidatedError(data.error))
            }
        } catch (error) {
            console.error('Error validating logo token:', error.message)
            // Puedes despachar una acción de error si es necesario
            dispatch(logoTokenValidatedError(error.message))
        }
    }
}

const importFoodStalls = (options) => {
  return async (dispatch, getState) => {
    const state = getState()

    const res = await callApi(
      `/sys_company/import_food_stalls`,
      {
        method: 'POST',
        headers: {
          Authorization: state.app.user.token,
        },
        body: JSON.stringify({
          options,
        }),
        successMessage: `Se registraron los puestos correctamente.`,
      }
    )
    showSuccessMessage('Se registraron los puestos correctamente.')
    return res.body
  }
}

export default {
    ...actions,
    deleteSysCompanyAndUser,
    loadSysCompanysClientPortal,
    getSysCompany,
    updateSysCompany,
    setOrder,
    getFoodStalls,
    loadFoodStalls,
    importFoodStalls
}
